import { Component, OnInit } from '@angular/core';
import { VideoService } from "../shared/video.service";
import { PhotoService } from "../shared/photo.service";

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

    constructor(private videoService: VideoService, private photoService: PhotoService) {
    }

    ngOnInit() {
        this.loadVideos();
        this.loadPhotos();
    }

    videos = <any>[];
    photos = <any>[];

    loadVideos() {
        this.videoService.getVideos()
            .then(data => {
                console.log('data: ', data);
                this.videos = data['objects'].filter(video =>
                    video.is_360_video && video.video && video.video.image
                );
            })
            .catch(errors => {
                console.log('errors: ', errors);
            })
    }

    loadPhotos() {
        this.photoService.getPhotos()
            .then(data => {
                console.log('data: ', data);
                this.photos = data['objects'];
            })
            .catch(errors => {
                console.log('errors: ', errors);
            })
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/gallery/gallery.component.ts